import { useState } from "react";
import { useUsage } from "../../contexts/UsageContext";
import { createPortalSession, STRIPE_ENABLED } from "../../lib/api/billing";
import { BarChart3, ExternalLink, Loader2 } from "lucide-react";

export function UsageIndicator() {
  const { usage, isLoading, hasSubscription, isAdminManaged } = useUsage();
  const [portalLoading, setPortalLoading] = useState(false);

  if (isLoading || !hasSubscription || !usage) return null;

  const percentage = Math.round((usage.remaining / usage.limit) * 100);
  const label = usage.metering_mode === "chats" ? "conversations" : "messages";
  const resetDate = new Date(usage.period_end).toLocaleDateString("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  let colorClass = "bg-brand-teal";
  let textColorClass = "text-brand-teal";
  if (percentage <= 20) {
    colorClass = "bg-brand-error";
    textColorClass = "text-brand-error";
  } else if (percentage <= 50) {
    colorClass = "bg-brand-warning";
    textColorClass = "text-brand-warning";
  }

  const handleManageSubscription = async () => {
    setPortalLoading(true);
    try {
      const { portal_url } = await createPortalSession();
      window.location.href = portal_url;
    } catch (err: any) {
      // Gracefully handle admin-assigned subscriptions (no stripe_customer_id)
      if (err?.response?.status === 400) {
        // Subscription is managed by admin, no portal available
        return;
      }
      console.error("Failed to open billing portal:", err);
    } finally {
      setPortalLoading(false);
    }
  };

  return (
    <div className="px-4 py-3">
      <div className="flex items-center gap-2 mb-1">
        <BarChart3 className={`w-4 h-4 ${textColorClass}`} />
        <span className="text-xs text-brand-muted">
          {usage.remaining} / {usage.limit} {label} restants
        </span>
      </div>
      <div className="w-full bg-brand-surface rounded-full h-1.5 mb-1.5">
        <div
          className={`h-1.5 rounded-full ${colorClass} transition-all`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-[10px] text-brand-muted">
        Votre utilisation se réinitialise le {resetDate}
      </p>
      {isAdminManaged ? (
        <p className="mt-2 text-[11px] text-brand-muted">
          Votre abonnement est géré par un administrateur.
        </p>
      ) : STRIPE_ENABLED ? (
        <button
          onClick={handleManageSubscription}
          disabled={portalLoading}
          className="mt-2 flex items-center gap-1 text-[11px] text-brand-teal hover:text-brand-primary transition-colors disabled:text-brand-muted"
        >
          {portalLoading ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            <ExternalLink className="w-3 h-3" />
          )}
          Gérer mon forfait
        </button>
      ) : null}
    </div>
  );
}
